import { createFileRoute } from '@tanstack/react-router';

import { getPendingDepositQueryOptions } from '@/_pages/deposits/api-service';
import Loading from '@/_pages/deposits/pending-deposit-profile/loading';

export const Route = createFileRoute('/_private/pending-deposits/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getPendingDepositQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
